import type { FaireProductEntity } from "../../entity_types/product";

export const p_cbc9pyx6r4: FaireProductEntity = {
  token: "p_cbc9pyx6r4",
  type: "product",
  name: "Feral Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/93de799c890cfe5948fa78e3c12e0b748d28a0c348053b289b43b0005d10fe91.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/90eb8e4e6ce44197f7f20f3e2a03e3731dac79aeddae3f8490f2ae3ee8e7c4f9.jpeg",
    "https://cdn.faire.com/fastly/7e8a528bdc5e7b3121eacff5d59bc782867649d56abd1fcd226df7462997b22d.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/2a256ac8f2e932f2f5da4f5657fde222165cc730d553f66974656fecb5ba9240.jpeg",
    "https://cdn.faire.com/fastly/4ffb43c2ba1063ca4e149eb7e2d1159cabc0e5575368da0e9ede79f9cfbe5cfe.jpeg",
    "https://cdn.faire.com/fastly/a1a3591969d8f6e210b17b1cec1c275d5558b6761fac8a333c1c15cf336c3cf4.jpeg",
    "https://cdn.faire.com/fastly/04c81f556948d2e252cdb1132164fac3de589f91223575b109590ee1ce171c07.jpeg",
    "https://cdn.faire.com/fastly/79c83d7e29c440bd95e6f5e6e7ce3c58a123907fc8cfececc83f368c7b9e292d.jpeg"
  ],
  priceDollars: 6.75,
  description: "Sometimes all it takes is a single word to let the world know what's up. These FERAL socks pair perfectly with your general disregard for indoor voices and chaotic energy. Wear 'em loud and proud baby!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:50.343Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
